@if (patient0() && !enCoursDeChargement0()) {
  <!-- patient chargé -->

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    <app-dossier-title-group
      [patient]="patient0()"
      [enCoursDeChargement]="enCoursDeChargement0()"
      [activite]="libelleActivite ? activite : undefined"
    />
  </td>

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    {{ patient0()!.dateDeNaissance | date: "dd/MM/yyyy" }}
  </td>

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    {{ patient0()!.patientComplement?.dateInstallation | date: "dd/MM/yyyy" }}
  </td>

  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
    >
      {{ patient0()!.patientComplement?.iahInitiale ?? "Pas de donnée" }}
    </td>
  }
  @if (dosActiviteList.includes("O2COV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
    >
      {{ patient0()!.tableauDeBord?.traitement?.value ?? "Pas de donnée" }}
    </td>
  }
  @if (dosActiviteList.includes("O2COV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.deambulation?.value ?? "--" }}
    </td>
  }
  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("O2COV") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-' + (patient0()!.obs | obsStatut)]"
    >
      {{ (patient0()!.obs?.value | obs) ?? "--" }}
    </td>
  }
  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-' + (patient0()!.iahResiduel | iahResiduelStatut)]"
    >
      {{ (patient0()!.iahResiduel?.value | iahResiduel) ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-' + (patient0()!.fuites | fuitesStatut)]"
    >
      {{ (patient0()!.fuites?.value | fuites) ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ (patient0()!.tableauDeBord?.p90_95?.value | pression) ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.debit02Repos?.value ?? "X" }} -
      {{ patient0()!.tableauDeBord?.debit02Effort?.value ?? "X" }}
    </td>
  }
  @if (dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.duree?.value ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.fuitesMediane?.value ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.volumeCourantMediane?.value ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{
        patient0()!.tableauDeBord?.frequenceRespiratoireMediane?.value ?? "--"
      }}
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.debitMin?.value ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.debitMax?.value ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.dureeMin?.value ?? "--" }}
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      [class]="['statut-info']"
    >
      {{ patient0()!.tableauDeBord?.dureeMax?.value ?? "--" }}
    </td>
  }

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    @if (patient0()!.tableauDeBord?.commentaire) {
      <div
        tuiComment="left"
        tuiHintAppearance="light"
        tuiHintDirection="left"
        [tuiHint]="tooltip"
        [ngClass]="{ comment: true }"
      >
        &nbsp;&nbsp;...&nbsp;&nbsp;
      </div>
      <ng-template #tooltip>
        <div>
          {{ patient0()!.tableauDeBord!.commentaire?.value }}
        </div>
      </ng-template>
    } @else {
      <div tuiComment="left">&nbsp;&nbsp;ø&nbsp;&nbsp;</div>
    }
  </td>

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
    [class]="[
      'date-validite-precedente-prescription',
      'statut-' +
        (getVeille(patient0()!.premierePrescriptionNonTransmise?.dateDebut) ??
          patient0()!.dernierePrescription?.dateFin | dateEcheanceStatut),
    ]"
  >
    {{
      getVeille(patient0()!.premierePrescriptionNonTransmise?.dateDebut) ??
        patient0()!.dernierePrescription?.dateFin | date: "dd/MM/yyyy"
    }}
  </td>
  <td
    tuiTd
    class="signature-en-masse"
    (click)="
      patient0()?.dernierePrescription?.dateRetour == null &&
      !patient0()?.dernierePrescription?.prescriptionForm &&
      patient0()?.canSign &&
      patient0()?.acceptOrdonnance()
        ? check(patient?.id ?? 0)
        : null
    "
  >
    @if (patient0()!.nombrePrescriptionEnCoursDeTransmission == 1) {
      <tui-chip iconStart="@tui.hourglass" appearance="outline">
        {{
          patient0()!.dernierePrescriptionFormEnCoursDeTransmission?.type
            ?.nom ??
            patient0()!.dernierePrescriptionFormEnCoursDeTransmission?.typeSlug
        }}
        transmise le
        {{
          patient0()!.dernierePrescriptionFormEnCoursDeTransmission?.createdAt
            | date: "dd/MM/yyyy"
        }}
      </tui-chip>
    } @else if (
      (patient0()!.nombrePrescriptionEnCoursDeTransmission ?? 0) > 1
    ) {
      <tui-chip iconStart="@tui.hourglass" appearance="outline">
        {{ patient0()!.nombrePrescriptionEnCoursDeTransmission! }}
        prescriptions transmisent le
        {{
          patient0()!.dernierePrescriptionFormEnCoursDeTransmission?.createdAt
            | date: "dd/MM/yyyy"
        }}
      </tui-chip>
    }

    @if ((patient0()!.nombrePrescriptionEnAttente ?? 0) > 1) {
      <tui-chip iconStart="@tui.triangle-alert" appearance="accent">
        {{ patient0()!.nombrePrescriptionEnAttente }}
        prescriptions en attente
      </tui-chip>
    } @else if (
      (patient0()!.nombrePrescriptionEnAttente ?? 0) == 1 &&
      (patient0()!.dernierePrescription?.dateRetour != null ||
        patient0()!.dernierePrescription?.prescriptionForm)
    ) {
      <tui-chip iconStart="@tui.triangle-alert" appearance="accent">
        {{ patient0()!.nombrePrescriptionEnAttente }}
        ancienne prescription en attente
      </tui-chip>
    } @else {
      @if (dosActiviteList.includes("PPC")) {
        @if (patient0()?.acceptOrdonnance()) {
          @if (
            patient0()?.dernierePrescription?.dateRetour == null &&
            !patient0()?.dernierePrescription?.prescriptionForm &&
            patient0()?.canSign
          ) {
            <input [checked]="signMass" tuiCheckbox type="checkbox" />
          }
          <span>Ordonnance</span>
        } @else {
          @if (authService.getUser()?.role?.slug == "liberal") {
            <span>DAP Amelipro</span>
          } @else {
            <span>DAP</span>
          }
        }
      }
    }
  </td>
} @else if (patient0()) {
  <!-- patient partiellement chargé -->

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    <app-dossier-title-group
      [patient]="patient0()"
      [enCoursDeChargement]="enCoursDeChargement0()"
      [activite]="libelleActivite ? activite : undefined"
    />
  </td>

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    {{ patient0()!.dateDeNaissance | date: "dd/MM/yyyy" }}
  </td>

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
  >
    {{ patient0()!.patientComplement?.dateInstallation | date: "dd/MM/yyyy" }}
  </td>

  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
    >
      {{ patient0()!.patientComplement?.iahInitiale ?? "Pas de donnée" }}
    </td>
  }
  @if (dosActiviteList.includes("O2COV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      XXXXXXXXXXXXX
    </td>
  }
  @if (dosActiviteList.includes("O2COV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("O2COV") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0 - 0
    </td>
  }
  @if (dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td
      tuiTd
      [routerLink]="['/patient', patient!.id]"
      [queryParams]="{ activite: activite }"
      class="placeholder"
    >
      0.00
    </td>
  }

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
    class="placeholder"
  >
    <div
      tuiComment="left"
      tuiHintAppearance="light"
      tuiHintDirection="left"
      [ngClass]="{ comment: true }"
    >
      &nbsp;&nbsp;...&nbsp;&nbsp;
    </div>
  </td>

  <td
    tuiTd
    [routerLink]="['/patient', patient!.id]"
    [queryParams]="{ activite: activite }"
    class="placeholder date-validite-precedente-prescription"
  >
    <span> 00/00/0000 </span>
  </td>
  <td tuiTd class="signature-en-masse"></td>
} @else {
  <!-- patient pas chargé -->

  <td tuiTd class="placeholder">
    NOM______ Prénom______ (M.)
    <tui-icon size="s" icon="@tui.circle-dashed" />
  </td>
  <td tuiTd class="placeholder">00/00/0000</td>
  <td tuiTd class="placeholder">00/00/0000</td>

  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td tuiTd>0.00</td>
  }
  @if (dosActiviteList.includes("O2COV")) {
    <td tuiTd class="placeholder">XXXXXXXXXXXXX</td>
  }
  @if (dosActiviteList.includes("O2COV")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("O2COV") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (
    dosActiviteList.includes("PPC") ||
    dosActiviteList.includes("OHD") ||
    dosActiviteList.includes("O2PPC") ||
    dosActiviteList.includes("O2VNI")
  ) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("PPC") || dosActiviteList.includes("O2PPC")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")) {
    <td tuiTd class="placeholder">0 - 0</td>
  }
  @if (dosActiviteList.includes("O2COV") || dosActiviteList.includes("O2VNI")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("OHD") || dosActiviteList.includes("O2VNI")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td tuiTd class="placeholder">0.00</td>
  }
  @if (dosActiviteList.includes("O2 AV")) {
    <td tuiTd class="placeholder">0.00</td>
  }

  <td tuiTd class="placeholder">
    <div tuiComment="left" [ngClass]="{ comment: true }">
      &nbsp;&nbsp;ø&nbsp;&nbsp;
    </div>
  </td>
  <td tuiTd class="placeholder date-validite-precedente-prescription">
    00/00/0000
  </td>
  <td tuiTd class="signature-en-masse"></td>
}
